import { useMutation } from "react-query";
import {
  IssuingStatusRequestParams,
  updateVehiclePremiumBookingIssuingStatusInfo,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const updateVehiclePremiumBookingIssuingStatus = async ({
  rowVersion,
  params,
}: {
  rowVersion: string;
  params: IssuingStatusRequestParams;
}) => {
  return await updateVehiclePremiumBookingIssuingStatusInfo(rowVersion, params);
};

export function useUpdateVehiclePremiumBookingIssuingStatus() {
  return useMutation(updateVehiclePremiumBookingIssuingStatus, {
    mutationKey: MUTATION_KEYS.updateVehiclePremiumBookingIssuingStatus,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
